import _ from 'lodash'

export default {
  setVouchers(state, items) {
    state.vouchers = state.vouchers.concat(items)
  },
  updateFullList(state, items) {
    state.vouchers = items
  },
  pushVoucher(state, item) {
    state.vouchers.push(item)
  },
  removeVoucher(state, code) {
    const index = _.findIndex(state.vouchers, voucher => voucher.code === code)

    state.vouchers.splice(index, 1)
  },
}
